export const initializeRecordingContext = () => {
    return {
        audioProcessor: null,
        audioContext: null,
        sessionId: '',
        sources: [],
        streamNames: [],
        streams: [],
        volumeInterval: null,
    };
};
